import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden'
import ImageDesktop from 'assets/illustrations/error-500-d.svg'
import ImageMobile from 'assets/illustrations/error-500-m.svg'
import useTranslation from 'hooks/useTranslations'
import { redirectToLogin } from 'services/auth/keycloak-api'
import useStyles from './styles'

const Error500 = () => {
  const t = useTranslation()
  const classes = useStyles()

  return (
    <Box my={3} display="flex" flexDirection="column" alignItems="center">
      <Typography variant="h1" gutterBottom>
        {t('error:500-title')}{' '}
        <span role="img" aria-label="eyes">
          👀
        </span>
      </Typography>
      <Box mb={2} maxWidth={440} textAlign="center">
        <Typography variant="subtitle1" color="textSecondary">
          {t('error:500-subtitle')}
        </Typography>
      </Box>
      <Box mb={3}>
        <Button variant="contained" color="primary" onClick={redirectToLogin}>
          {t('error:500-action')}
        </Button>
      </Box>
      <Hidden smUp>
        <img src={ImageMobile} alt="" className={classes.image} />
      </Hidden>
      <Hidden xsDown>
        <img src={ImageDesktop} alt="" className={classes.image} />
      </Hidden>
    </Box>
  )
}

export default Error500
